<p-panel [style]="{ 'margin-top': '1em' }">
  <p-header class="flex justify-content-between">
    <div>Site Opening Hours</div>
    <button *ngIf="editAllowed" pButton icon="fa ui-icon-edit" (click)="editHours()"></button>
  </p-header>

  <div class="p-2">
    <div class="pick-up-color my-2" style="position: relative; margin-bottom: 0">
      <i class="vme-material-icons route-icon">&#xe805;</i>
      <div style="margin-left: 2em; font-weight: bold; font-size: 12px">Pick-up</div>
    </div>
    <ng-container *ngIf="taskSiteOpeningHours">
      <div *ngFor="let hours of taskSiteOpeningHours.pickup">
        <ng-template
          [ngTemplateOutlet]="openingHoursRow"
          [ngTemplateOutletContext]="{ $implicit: hours }"
        ></ng-template>
      </div>
    </ng-container>

    <div class="drop-off-color mb-2 mt-4" style="position: relative; margin-bottom: 0">
      <i class="vme-material-icons route-icon">&#xe804;</i>
      <div style="margin-left: 2em; font-weight: bold; font-size: 12px">Drop-off</div>
    </div>
    <ng-container *ngIf="taskSiteOpeningHours">
      <div *ngFor="let hours of taskSiteOpeningHours.dropOff">
        <ng-template
          [ngTemplateOutlet]="openingHoursRow"
          [ngTemplateOutletContext]="{ $implicit: hours }"
        ></ng-template>
      </div>
    </ng-container>
  </div>
</p-panel>

<ng-template #openingHoursRow let-hours>
  <ng-container *ngIf="hours && !hours.unspecified">
    <div
      style="font-family: 'Courier New', Courier, monospace"
      class="mb-1"
      *ngIf="!hours.isClosed"
    >
      <b>{{ hours.dayOfWeek.substring(0, 3) }}:</b> {{ hours.open }} - {{ hours.close }}
    </div>
    <div style="font-family: 'Courier New', Courier, monospace" class="mb-1" *ngIf="hours.isClosed">
      <b>{{ hours.dayOfWeek.substring(0, 3) }}:</b> closed
    </div>
  </ng-container>
</ng-template>

<p-dialog
  [(visible)]="editVisible"
  header="Edit Site Opening Times"
  [style.width]="'800px'"
  [modal]="true"
>
  <div class="grid w-full">
    <div class="col-6">
      <div class="text-pick-up-colour font-bold">
        <i class="vme-material-icons">&#xe805;</i> Pick-up
      </div>

      <div *ngIf="pickupLocation" class="font-bold text-gray-600">
        <div>
          <div>{{ pickupLocation.businessName }}</div>
          <div
            *ngFor="
              let item of pickupLocation.primaryAddress
                .replace(pickupLocation.postcode, '')
                .split(',')
            "
          >
            {{ item }}
          </div>
          <div>{{ pickupLocation.postcode | postcode }}</div>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="text-drop-off-colour font-bold">
        <i class="vme-material-icons">&#xe804;</i> Drop-off
      </div>

      <div *ngIf="dropOffLocation" class="font-bold text-gray-600">
        <div>
          <div>{{ dropOffLocation.businessName }}</div>
          <div
            *ngFor="
              let item of dropOffLocation.primaryAddress
                .replace(dropOffLocation.postcode, '')
                .split(',')
            "
          >
            {{ item }}
          </div>
          <div>{{ dropOffLocation.postcode | postcode }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="grid w-full">
    <div class="col-6">
      <customer-sites-opening-times
        *ngIf="pickupSiteHoursFormGroup"
        [openingTimesForm]="pickupSiteHoursFormGroup"
      ></customer-sites-opening-times>
    </div>
    <div class="col-6">
      <customer-sites-opening-times
        *ngIf="dropOffSiteHoursFormGroup"
        [openingTimesForm]="dropOffSiteHoursFormGroup"
      ></customer-sites-opening-times>
    </div>
  </div>
  <p-footer>
    <button
      label="Save"
      *ngIf="pickupSiteHoursFormGroup && dropOffSiteHoursFormGroup"
      pButton
      (click)="saveOpeniningHours()"
      [disabled]="pickupSiteHoursFormGroup.invalid || dropOffSiteHoursFormGroup.invalid"
    ></button>
  </p-footer>
</p-dialog>
